import React from 'react';
import { Calendar } from 'lucide-react';

interface IFTDConfigProps {
  config: {
    dimanchesParMois: number;
    joursFeriesTravailles: string[];
  };
  onChange: (config: { dimanchesParMois?: number; joursFeriesTravailles?: string[] }) => void;
}

const JOURS_FERIES = [
  'Jour de l\'An', 'Lundi de Pâques', 'Fête du Travail', 'Victoire 1945',
  'Ascension', 'Lundi de Pentecôte', 'Fête Nationale', 'Assomption',
  'Toussaint', 'Armistice 1918', 'Noël'
];

export default function IFTDConfig({ config, onChange }: IFTDConfigProps) {
  const handleDimanchesChange = (dimanchesParMois: number) => {
    onChange({ dimanchesParMois });
  };

  const handleJourFerieToggle = (jourFerie: string) => {
    const newJoursFeries = config.joursFeriesTravailles.includes(jourFerie)
      ? config.joursFeriesTravailles.filter(j => j !== jourFerie)
      : [...config.joursFeriesTravailles, jourFerie];
    
    onChange({ joursFeriesTravailles: newJoursFeries });
  };

  return (
    <div className="space-y-4">
      {/* Nombre de dimanches par mois */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Calendar className="w-4 h-4 inline mr-1" />
          Nombre de dimanches travaillés par mois
        </label>
        <div className="flex gap-2">
          {[0, 1, 2, 3, 4].map((nb) => (
            <button
              key={nb}
              onClick={(e) => {
                e.stopPropagation();
                handleDimanchesChange(nb);
              }}
              className={`px-3 py-1 text-sm rounded-full transition-colors ${
                config.dimanchesParMois === nb
                  ? 'bg-blue-600 text-white'
                  : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
            >
              {nb}
            </button>
          ))}
        </div>
      </div>

      {/* Jours fériés travaillés */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Jours fériés travaillés dans l'année
        </label>
        <div className="grid grid-cols-2 gap-2">
          {JOURS_FERIES.map((jourFerie) => (
            <label
              key={jourFerie}
              onClick={(e) => e.stopPropagation()}
              className={`flex items-center p-2 rounded cursor-pointer transition-colors ${
                config.joursFeriesTravailles.includes(jourFerie)
                  ? 'bg-blue-100 border border-blue-300'
                  : 'bg-white border border-gray-200 hover:bg-gray-50'
              }`}
            >
              <input
                type="checkbox"
                checked={config.joursFeriesTravailles.includes(jourFerie)}
                onChange={(e) => {
                  e.stopPropagation();
                  handleJourFerieToggle(jourFerie);
                }}
                className="sr-only"
              />
              <span className={`text-xs ${
                config.joursFeriesTravailles.includes(jourFerie)
                  ? 'text-blue-800 font-medium'
                  : 'text-gray-700'
              }`}>
                {jourFerie}
              </span>
            </label>
          ))}
        </div>
        <div className="mt-2 text-xs text-gray-600">
          {config.joursFeriesTravailles.length} jour{config.joursFeriesTravailles.length > 1 ? 's' : ''} sélectionné{config.joursFeriesTravailles.length > 1 ? 's' : ''}
        </div>
      </div>
    </div>
  );
}